const moduleRoute = {
  path: '/context',
  name: 'Context',
  redirect: {
    name: 'ContextStatistics'
  },
  component: () => import('../Module.vue'),
  children: [
    {
      path: '/context/brief',
      name: 'ContextBrief',
      component: () => import('../views/Brief.vue')
    },
    {
      path: '/context/statistics',
      name: 'ContextStatistics',
      component: () => import('../views/Statistics.vue')
    },
    {
      path: '/context/documents',
      name: 'ContextDocuments',
      component: () => import('../views/Documents.vue')
    }
  ]
}

export default router => {
  router.addRoutes([moduleRoute])
}
